export const isNode = (ele) =>
	typeof Node === "object"
		? ele instanceof Node
		: ele && typeof ele === "object" && typeof ele.nodeType === "number" && typeof ele.nodeName === "string";
export const fileImage = (file) => (file?.type?.match(/image.*/) ? window.URL.createObjectURL(file) : false);
export const scrollToTop = () => {
	window.scrollTo({ behavior: "smooth", top: 0 });
	document.body.scrollTop = 0; // For Safari
	document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	document.body.focus();
};
export const scrollToElementBottom = (ele) => {
	if (!ele) return;
	const eleScrollHeight = getNodeScrollHeight(ele);
	ele.scrollTo({ behavior: "smooth", top: eleScrollHeight });
};
export const getNodeHeight = (ele) => {
	if (!isNode(ele)) return new Error("element isn't DOM node!");
	return ele.getBoundingClientRect().height || ele.clientHeight || 0;
};
export const getNodeScrollHeight = (ele) => {
	if (!isNode(ele)) return new Error("element isn't DOM node!");
	return ele.scrollHeight || 0;
};
export const getNodeTop = (ele) => {
	if (!isNode(ele)) return new Error("element isn't DOM node!");
	return ele.offsetTop || 0;
};
export const getNodeCSSPropertyValue = (ele, valueName) => {
	if (!isNode(ele)) return new Error("element isn't DOM node!");
	if (!valueName) return new Error("you should pass css value name");
	return window.getComputedStyle(ele, null).getPropertyValue(valueName);
};
export const getWindowScrollingValue = () =>
	(window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
export const scrollToAnchor = () => {
	setTimeout(() => {
		const hashParts = [...(window.location.hash.split("#") || [])].filter(Boolean);
		if (hashParts.length) document.querySelector(`#${hashParts[0]}`)?.scrollIntoView();
	}, 1000);
};
export const scrollToElement = (eleId = "") => {
	if (!eleId) return new Error("you should pass an element id value");
	const isElementIdStartWithHash = eleId.startsWith("#") || false;
	setTimeout(() => {
		document.querySelector(`${!isElementIdStartWithHash ? "#" : ""}${eleId}`)?.scrollIntoView();
	}, 500);
};

export const copyTextToClipboard = async (text) => {
	const value = String(text ?? "");
	if (navigator.clipboard?.writeText) {
		return navigator.clipboard.writeText(value);
	}

	const textarea = document.createElement("textarea");
	textarea.value = value;
	textarea.setAttribute("readonly", "");
	textarea.style.position = "fixed";
	textarea.style.left = "-9999px";
	document.body.appendChild(textarea);
	textarea.select();

	try {
		const copied = document.execCommand("copy");
		if (!copied) throw new Error("copy failed");
	} finally {
		document.body.removeChild(textarea);
	}
};

export const escapeString = (str) =>
	str
		.replace(/"/g, "'")
		.replace(/%/g, "%25")
		.replace(/#/g, "%23")
		.replace(/{/g, "%7B")
		.replace(/}/g, "%7D")
		.replace(/</g, "%3C")
		.replace(/>/g, "%3E")
		.replace(/\s+/g, " ")
		.replace(/&/g, "%26")
		.replace(/\|/g, "%7C")
		.replace(/\[/g, "%5B")
		.replace(/\]/g, "%5D")
		.replace(/\^/g, "%5E")
		.replace(/`/g, "%60")
		.replace(/;/g, "%3B")
		.replace(/\?/g, "%3F")
		.replace(/:/g, "%3A")
		.replace(/@/g, "%40")
		.replace(/=/g, "%3D");

export const getURLEncodedFromHTMLNode = (str = "", node = "") => {
	if (!str || !node) return "";
	const parser = new DOMParser();
	const doc = parser.parseFromString(str, "application/xhtml+xml");
	const domNode = doc.querySelector(node);
	if (!domNode || !isNode(domNode) || !domNode.outerHTML) return "";
	return `data:image/svg+xml,${escapeString(domNode.outerHTML)}`;
};
